import { z } from 'zod';

import { BankruptcyCh13PostPetitionPaymentConfig } from '../../../loan/WorkoutPlan';
import { BaseLoanEvent } from '../../BaseLoanEvent';

/**
 * Manually pushes a post-petition payment-config entry onto the active Chapter 13 plan — used when
 * a court orders a different monthly amount than the contractual one (e.g. a disputed payment
 * change), or to record a payer change. A payer-only change leaves `changeReason` blank.
 */
export const UpdateBankruptcyCh13PostPetitionPaymentConfigEvent = BaseLoanEvent.extend({
  type: z.literal('updateBankruptcyCh13PostPetitionPaymentConfig'),
  data: BankruptcyCh13PostPetitionPaymentConfig.pick({
    monthlyPaymentAmount: true,
    payer: true,
    effectiveDate: true,
    numberOfMonthsRemaining: true,
    changeReason: true,
  }),
});
export type UpdateBankruptcyCh13PostPetitionPaymentConfigEvent = z.infer<
  typeof UpdateBankruptcyCh13PostPetitionPaymentConfigEvent
>;
